import { useMutation } from 'react-query';

import { bulkAssignToUser as mutationFn } from 'api/endPoints/bulkAssignToUser';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationBulkUser = () => {
    return useMutation<string, QueryError, IBulkUserPayload>((params) => mutationFn(params));
};

interface IBulkUserPayload {
    bulkAssigneeToUserUniqIdNotification: number;
    bulkAssignee: number;
    filter: {
        filters: IFilter;
    };
    paging: {
        page: number;
        size: number;
    };
    withDetails: boolean;
}
